import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text } from '@mantine/core';
import { IconPlayerPlay } from '@tabler/icons-react';

function StartNode({ data, selected }: NodeProps) {
    return (
        <Box
            style={{
                background: '#10b981', // Green
                border: `2px solid ${selected ? '#374151' : 'transparent'}`,
                borderRadius: '20px', // More rounded for start
                padding: '8px 16px',
                minWidth: '100px',
                color: 'white',
                boxShadow: selected ? '0 4px 12px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
            }}
        >
            <IconPlayerPlay size={16} />
            <Text size="sm" fw={700}>
                Start
            </Text>
            <Handle type="source" position={Position.Bottom} />
        </Box>
    );
}

export default memo(StartNode);
